import React, { useMemo } from 'react';
import { translate } from '../../../services/translate';
import { OccurrencePriorities } from '../../../schemas/dispatch';
import FilterRadioList, { FilterListItem } from './FilterRadioList';

interface Props {
    value: OccurrencePriorities | 'all';
    setValue: React.Dispatch<React.SetStateAction<OccurrencePriorities | 'all'>>;
}

function PriorityList({ value, setValue }: Props) {
    const items: FilterListItem<OccurrencePriorities | 'all'>[] = useMemo(() => {
        const priorities: (OccurrencePriorities | 'all')[] = ['maximum', 'high', 'medium', 'low'];
        return priorities.map(priority => ({
            label: translate(priority),
            value: priority
        }));
    }, []);

    return <FilterRadioList items={items} value={value} setValue={setValue} clearValue='all' />;
}

export default PriorityList;
